<template>
<div class="mx-auto" style="max-width: 400px">
    <v-card class="IMThemeGray rounded-xl rounded-tl-0">
        <v-card-title
            class="IMThemeOrange py-2 text-white rounded-xl rounded-tl-0 justify-content-center"
        >
            {{ id == -1 ? "إضافة" : "تعديل" }}
        </v-card-title>
        <v-card-text>
            <v-form 
                ref="areaForm"
                v-model="valid"
            >
                <label for="city">المحافظة</label>
                <v-autocomplete
                    id="city"
                    v-model="areaForm.cityId"
                    :rules="cityId"
                    deletable-chips
                    dense
                    rounded
                    class="rounded-tl-0"
                    color="IMThemeGray"
                    item-color="IMThemeGray"
                    solo
                    :items="citiesList"
                    item-text="name"
                    item-value="id"
                >
                    <template v-slot:item="data">
                        <v-list-item-content
                            v-text="data.item.name"
                        ></v-list-item-content>
                    </template>
                </v-autocomplete>
                <label for="area">اسم المنطقة</label>
                <v-text-field
                    id="area"
                    v-model="areaForm.name"
                    class="rounded-tl-0"
                    rounded
                    :rules="name"
                    dense
                    solo
                ></v-text-field>

                <div class="text-center">
                    <v-btn
                        @click="SubmitSetArea()"
                        rounded
                        class="rounded-tl-0 px-8"
                        :disabled="!valid"
                    >
                        تم
                    </v-btn>
                </div>
                <div class="pt-3 text-center">
                    <router-link to="-1" v-if="id != -1">
                        <v-btn
                            outlined
                            rounded
                            color="white"
                            class="rounded-tl-0 px-8"
                        >
                            إلغاء التحديد
                        </v-btn>
                    </router-link>
                </div>
            </v-form>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    props: {
        id: String
    },
    data: () => ({
        valid: false,
        name: [
            v => !!v || 'يرجى كتابة اسم منطقة'
        ],
        cityId: [
            v => !!v || 'يرجى اختيار مدينة للمنطقة '
        ]
    }),
    mounted() {
        this.fetchCitiesList();
        if (this.id != -1) {
            this.fetchAreaForm(this.id);
        } else {
           this.$refs.areaForm.reset();
        }
    },
    computed: {
        ...mapGetters(["citiesList", "areaForm"])
    },
    methods: {
        ...mapActions([
            "fetchCitiesList",
            "fetchAreaForm",
            "setArea"
        ]),
        SubmitSetArea() {
            this.setArea(this.areaForm);
            this.$refs.areaForm.reset();
            if (this.id != -1) {
                this.$router.push("./-1");
            }
        }
    },
    watch: {
        id(newId) {
            if (newId != -1) {
                this.fetchAreaForm(this.id);
            } else {
                this.$refs.areaForm.reset();
            }
        }
    }
};
</script>
